import * as React from 'react';
import { Fun, IOWidget, mk_widget, nothing, option, Options, Unit, Widget } from '../widget';

export type N = 1 | 2 | 3 | 4 | 5 | 6

interface HnProps<i, o> {
  options?:Options
  n: N
  text: string
  input: i
  inner_widget: IOWidget<i, o>
  on_done: (output: o) => void
}

interface HnState<_i, _o> {}

class Hn<i, o> extends React.Component<HnProps<i, o>, HnState<i, o>> {
  constructor(props: HnProps<i, o>, context: any) {
    super(props, context)

    this.state = { value: props.input }
  }

  render() {
    return (
      <>
        {React.createElement(`h${this.props.n}`, {
            key:option("key", this.props.options),
            id:option("id", this.props.options),
            className:option("className", this.props.options),
            ...option("extraProperties", this.props.options)
          }, [ this.props.text])}
        {this.props.inner_widget(this.props.input).run(output => this.props.on_done(output))}
      </>
    )
  }
}

/** @deprecated Use [[wrapHTML]] instead. */
export const hn_io = function<i, o>(n: N, text: string, options?:Options): Fun<IOWidget<i, o>,IOWidget<i, o>> {
  return inner_widget => (input: i) => mk_widget({
    run: (on_done: (output: o) => void) =>
      React.createElement<HnProps<i, o>>(Hn, { on_done, inner_widget, input, text, n, options })
  })
}

/** @deprecated Use [[wrapHTML]] instead. */
export const hn = function<o>(n: N, text: string, options?:Options)  {
  return (inner_widget?:Widget<o>) : Widget<o> => hn_io<Unit, o>(n, text, options)(_ => inner_widget || nothing())({})
}
